import React from 'react';
import { TimePeriod } from '../../types/calculator';
import { TIME_PERIOD_LABELS } from '../../constants/defaults';

interface TimePeriodToggleProps {
  selected: TimePeriod;
  onChange: (period: TimePeriod) => void;
}

const periods: TimePeriod[] = ['day', 'week', 'month', 'quarter', 'year'];

export const TimePeriodToggle: React.FC<TimePeriodToggleProps> = ({
  selected,
  onChange,
}) => {
  return (
    <div className="w-full">
      <select
        value={selected}
        onChange={(e) => onChange(e.target.value as TimePeriod)}
        className="w-full px-4 py-1.5 text-sm font-medium bg-white border border-orange rounded-lg text-orange focus:outline-none focus:ring-2 focus:ring-orange focus:border-transparent"
      >
        {periods.map((period) => (
          <option key={period} value={period}>
            {TIME_PERIOD_LABELS[period]}
          </option>
        ))}
      </select>
    </div>
  );
};
